import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;

  height: 50px;
  background-color: #020202;
  box-shadow: 0px 5px 5px black;
`;

export const ContainerLogo = styled.div`
  margin: -5px 0 0 20px;
  h1 {
    font-family: "Pixel Text";
    font-size: 60px;
  }
`;

export const ContainerMenu = styled.div``;

export const IconMenuMobile = styled.div`
  float: right;
`;
